import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

/* Inline "MOCK" pill used by every card on the Dashboard to mark
   fixture content. Two surfaces use it:
     - card-title (whole card is fixture)
     - per-field (a single value falls back to fixture, e.g. the
       Safety card's `Days Without LTI` when no critical event has
       ever been emitted on the site).
   Pass `kind="badge"` for the per-field variant — it gets a left
   margin so it spaces nicely after an inline label. */

export function MockPill({ kind = 'title' }: { kind?: 'title' | 'badge' }) {
  const { t } = useTranslation();
  return (
    <span className={kind === 'badge' ? styles.badge : styles.pill}>
      {t('common.mock')}
    </span>
  );
}
